<template>
  <div
    :key="conversation.room"
    href="#"
    class="conversation"
    :class="{ unread: !conversation.read }"
  >
    <div
      class="content"
      @click.prevent="handleClick(conversation)"
    >
      <avatar
        v-if="subject && type === 'member'"
        :user="subject"
      />
      <group-icon
        v-else-if="subject && type === 'group'"
        :group="subject.id"
      />
      <div
        v-else-if="subject && type === 'post'"
        class="post-images"
      >
        <transition name="fade">
          <img
            v-if="subject.images[imageIdx]"
            :key="subject.images[imageIdx].id"
            :src="subject.images[imageIdx].url"
          >
          <div v-else>
            ?
          </div>
        </transition>
      </div>
      <div
        v-else
        class="placeholder"
      />

      <div>
        <span
          v-if="subject && type === 'group'"
          class="subject"
        >
          {{ subject.name }}
        </span>
        <span
          v-else-if="subject && type === 'post'"
          class="subject"
        >
          {{ subject.title }}
        </span>
        <span
          v-else-if="subject && type === 'member'"
          class="subject"
        >
          {{ subject.first_name }}
          {{ subject.last_name }}
        </span>
        <span v-else>
          {{ conversation.last_message.sender }}
        </span>

        <br>

        <!-- <div class="subject">
          {{ conversation.subject }}
        </div> -->

        <!-- <div
          class="subject"
          v-if="/^_group\./.test(conversation.room)"
        >
          {{ group(conversation.room).name }}
        </div>
        <div
          class="subject"
          v-else-if="/^_m2m\./.test(conversation.room)"
        >
          Direct Message
        </div> -->

        {{ conversation.last_message.message }}
      </div>
      <div class="timestamp">
        {{ dateFromNow(conversation.last_message.timestamp) }}
      </div>
    </div>
    <a
      href="#"
      class="close"
      @click.prevent="deleteConversation"
    >
      &times;
    </a>
  </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';
import GroupIcon from '@/components/GroupIcon.vue';

export default {
  name: 'ConversationItem',
  components: {
    Avatar,
    GroupIcon,
  },
  props: {
    conversation: { type: Object, required: true },
  },
  data() {
    return {
      subject: null,
      imageIdx: 0,
    };
  },
  computed: {
    type() {
      let type = 'unknown';
      if (/^_group\./.test(this.conversation.room)) {
        type = 'group';
      } else if (/^_m2m\./.test(this.conversation.room)) {
        type = 'member';
      } else if (/^_m2l\./.test(this.conversation.room)) {
        type = 'post';
      }
      return type;
    },
  },
  async mounted() {
    if (this.type === 'group') {
      this.subject = await this.group(this.conversation.room);
    } else if (this.type === 'post') {
      this.subject = await this.post(this.conversation.room);
      if (this.subject.images && this.subject.images.length > 0) {
        this.imageInterval = setInterval(() => {
          this.imageIdx = (this.imageIdx + 1) % this.subject.images.length;
        }, 10000);
      }
    } else if (this.type === 'member') {
      this.subject = await this.otherUser(this.conversation.room);
    }
  },
  destroyed() {
    clearInterval(this.imageInterval);
  },
  methods: {
    async handleClick(conversation) {
      await this.$root.markChatRead(conversation.last_message.id);

      let route = null;
      if (this.type === 'group') {
        route = {
          name: 'chat_group',
          params: { id: this.subject.id },
        };
      } else if (this.type === 'member') {
        route = {
          name: 'message_profile',
          params: { id: this.subject.id },
        };
      } else if (this.type === 'post') {
        route = {
          name: 'message_listing',
          params: {
            id: this.subject.id,
            user: this.secondId(this.conversation.room),
          },
        };
      }
      if (route) {
        this.$router.push(route);
      }
    },
    async deleteConversation() {
      await this.api({
        url: 'chat/conversations/',
        json: { room: this.conversation.room },
        method: 'DELETE',
      });
      this.$emit('deleted', this.conversation);
    },
    group(room) {
      const id = parseInt(room.slice(7), 10);
      return this.userGroups.find(g => g.id === id);
    },
    async otherUser(room) {
      const id = this.otherId(room);
      const response = await this.api({ url: `users/${id}/` });
      return response.body;
    },
    async post(room) {
      const id = this.firstId(room);
      const response = await this.api({ url: `posts/${id}/` });
      return response.body;
    },
    otherId(room) {
      return room.slice(5).split('.').map(i => parseInt(i, 10)).filter(i => i !== this.userData.id)[0];
    },
    firstId(room) {
      return parseInt(room.slice(5).split('.')[0], 10);
    },
    secondId(room) {
      return room.slice(5).split('.').map(i => parseInt(i, 10))[1];
    },
  },
};
</script>

<style lang="scss" scoped>
  .conversation {
    color: inherit;
    background-color: #fff;
    border: 1px solid var(--gray);
    border-top: none;
    font-size: 80%;
    transition: background-color 0.2s ease-in-out;
    padding: 0.5rem;
    display: flex;

    &:focus,
    &:hover {
      background-color: var(--gray-lightest);
    }
    &:first-child {
      border-top: 1px solid var(--gray);
    }
  }
  .conversation .close {
    min-width: 35px;
    text-align: center;
    justify-content: center;
    display: flex;
    flex-direction: row;
    flex: 0 0 auto;
    cursor: pointer;
  }
  .conversation .content {
    flex: 1 1 auto;
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: auto 1fr auto;
    cursor: pointer;
  }

  .unread {
    background-color: var(--yellow-lighter);

    &:focus,
    &:hover {
      background-color: var(--yellow-light);
    }
  }
  .placeholder,
  .post-images {
    max-width: 36px;
    max-height: 36px;
  }
  .post-images {
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    display: grid;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
  }
  .post-images img {
    border-radius: 5px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    object-fit: cover;
    grid-row: 1 / 1;
    grid-column: 1 / 1;
  }
  .subject {
    font-weight: bold;
  }

  .timestamp {
    align-self: end;
  }

  @media (min-width: 1024px) {
    .conversation:first-child {
      margin-top: 0;
    }

    .container {
      padding: 0;
    }
  }
</style>
